export const Rights = [
    "WEB_MODULE_APPOINTMENTS_WRITE"
]
